import { customerDetails } from 'src/app/models/customers/details';

// Index Expert environments are labelled by customer_cd instead of "<meta_source> - <customer_name>"
const indexExpertLabels: Record<string, string> = {
  IE: 'CPLs - Index Expert',
  MAPS: 'MAPs - Index Expert',
  POR: 'PORs - Index Expert'
};

export function getCustomerDisplayName(customer: Pick<customerDetails, 'customer_cd' | 'meta_source' | 'customer_name'>): string {
  return indexExpertLabels[customer.customer_cd] ?? `${customer.meta_source} - ${customer.customer_name}`;
}

export function sortCustomersByDisplayName<T extends Pick<customerDetails, 'customer_cd' | 'meta_source' | 'customer_name'>>(customers: T[]): T[] {
  return [...customers].sort((a, b) =>
    getCustomerDisplayName(a).localeCompare(getCustomerDisplayName(b), undefined, { sensitivity: 'base' }));
}
